import {plainJSTranslator} from "../../../common/PlainJSTranslator";
import {messages} from "../../common/Translations";
import * as roles from "../../../services/access/roles";

export default [
    {
        id: 'article-categories',
        to: '/kategorier/nyheder',
        title: plainJSTranslator.formatMessage(messages.articleCategoriesList),
        roles: [roles.SUPER_ADMINISTRATOR],
    },
    {
        id: 'categories',
        to: '/kategorier',
        title: 'Administrer kategorier',
        icon: 'mdi mdi-account-settings-variant',
        roles: [roles.SUPER_ADMINISTRATOR],
    },
    {
        id: 'park-machine-categories',
        to: '/park/kategorier',
        title: 'Maskinpark kategorier',
        icon: 'mdi mdi-account-settings-variant',
        roles: [roles.SUPER_ADMINISTRATOR],
    },
    {
        id: 'rent-machine-categories',
        to: '/rent/kategorier',
        title: 'Udlejningskategorier',
        icon: 'mdi mdi-account-settings-variant',
        roles: [roles.SUPER_ADMINISTRATOR],
    },
    {
        id: 'competencies',
        to: '/administrer-kompetencer',
        title: 'Administrer kompetencer',
        icon: 'mdi mdi-account-settings-variant',
        roles: [roles.SUPER_ADMINISTRATOR],
    },
    {
        id: 'keywords-packs',
        to: '/søgeordpakker',
        title: 'Søgeordpakker',
        // title: plainJSTranslator.formatMessage(messages.sideBarWebMasterKeywordsPacksList),
        roles: [roles.FBG_WEBMASTER],
    }
];


// WEBPACK FOOTER //
// ./web/src/components/navigation/items/superAdmnItems.jsx